class UnitsWeightService {
  constructor (http) {
    this.http = http
  }

  async getAll () {
    const result = await this.http.get('/units-weight')
    return result.data
  }

  async getUnitWeights () {
    const result = await this.http.get('/units-weight')
    return result.data
  }
}

export default UnitsWeightService
